document.addEventListener("DOMContentLoaded", () => {
  const marqueeWrappers = document.querySelectorAll(".reviews-marquee-wrapper");

  marqueeWrappers.forEach((wrapper) => {
    const isScrollingDisabled = wrapper.getAttribute("data-disable-scrolling") === "true";
    const marquee = wrapper.querySelector(".reviews-marquee-content");

    if (!marquee) return;

    const reviewSegments = marquee.querySelectorAll(".reviews-marquee-segment");

    if (reviewSegments.length === 0) return;

    // Fisher-Yates shuffle for uniform randomness
    const reviews = Array.from(reviewSegments);
    for (let i = reviews.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [reviews[i], reviews[j]] = [reviews[j], reviews[i]];
    }

    // Pick up to 4 reviews to display
    const selected = reviews.slice(0, 4);
    const html = selected.map((el) => el.outerHTML).join("");

    // Single duplication is sufficient for seamless CSS looping
    marquee.innerHTML = isScrollingDisabled ? html : html + html;
  });
});
